import { useState } from "react";
import { motion } from "framer-motion";
import { Zap } from "lucide-react";
import { CheckoutDialog } from "./CheckoutDialog";

export const ProductCard = ({ p, index }) => {
  const [open, setOpen] = useState(false);
  const [spot, setSpot] = useState({ x: 50, y: 30 });

  return (
    <motion.article
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: (index % 4) * 0.08 }}
      onMouseMove={(e) => {
        const r = e.currentTarget.getBoundingClientRect();
        setSpot({ x: ((e.clientX - r.left) / r.width) * 100, y: ((e.clientY - r.top) / r.height) * 100 });
      }}
      className="product-card group relative flex flex-col border border-white/10 bg-[#100719] hover:border-gold/50 transition-colors duration-500"
      style={{ "--sx": `${spot.x}%`, "--sy": `${spot.y}%` }}
      data-testid={`product-card-${p.id}`}
    >
      <div className="relative aspect-square overflow-hidden">
        <img src={p.img} alt={p.name} loading="lazy" className="w-full h-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-[1.07]" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#100719] via-transparent to-transparent" />
        <span className="absolute top-3 left-3 font-mono text-[11px] text-violet-100 tracking-widest bg-black/60 backdrop-blur px-1.5 py-0.5">{String(index + 1).padStart(2, "0")}</span>
        {p.tag && (
          <span className="absolute top-3 right-3 bg-gold text-[#140a22] text-[10px] font-bold tracking-[0.2em] uppercase px-2.5 py-1" data-testid={`product-tag-${p.id}`}>{p.tag}</span>
        )}
      </div>
      <div className="relative flex flex-col flex-1 p-5 sm:p-6">
        <div className="flex items-baseline gap-3">
          <span className="font-mono text-xl font-bold text-gold" data-testid={`product-price-${p.id}`}>${p.price}</span>
          {p.was && <span className="font-mono text-sm text-violet-300/70 line-through" data-testid={`product-was-${p.id}`}>${p.was}</span>}
        </div>
        <h3 className="mt-3 font-display font-black uppercase text-xl leading-tight text-white">{p.name}</h3>
        <p className="mt-2 text-sm text-violet-200/80 leading-relaxed flex-1">{p.was ? `Was $${p.was}. ` : ""}{p.desc}</p>
        <button onClick={() => setOpen(true)} className="btn-gold mt-6 w-full py-3.5 text-[11px]" data-testid={`get-access-btn-${p.id}`}>
          <Zap className="w-3.5 h-3.5 mr-2" />Get access
        </button>
        <CheckoutDialog product={p} open={open} onOpenChange={setOpen} />
      </div>
    </motion.article>
  );
};
